import { render, staticRenderFns } from "./ebookDetail.vue?vue&type=template&id=52b37cb0"
import script from "./ebookDetail.vue?vue&type=script&lang=js"
export * from "./ebookDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports